export enum DominoSwissModuleType {
  DominoSwissMXFEShutter = '{3AA1A627-78B0-4E17-9206-0BB012094D1C}',
  DominoSwissMXSLIM = '{0A5C3DFA-CD52-4529-82F1-99DCFCF8A7A2}',
  DominoSwissMXFEULTRA = '{FE8DB15B-6FD0-F9A7-D7FD-B5188D368528}',
  DominoSwissLXDIMM = '{5ED1AA15-6D8B-4DA8-B1C8-781D24442288}',
  DominoSwissLXRLUP = '{E498DF29-57B1-48F5-8C13-A4673EE0EF9E}',
  DominoSwissMAG = '{26AE9337-13A8-4BF8-99D0-EE11D91FDEE2}',
  DominoSwissWeatherstation = '{B3F0007D-44EE-460B-81D1-5A74C85EE29C}',
  DominoSwissGroup = '{7F5C8432-CEAC-45A7-BF96-4BBC3CF04B57}',

  DominoSwissPIR = '{CE892EF8-C01D-43D2-BBA7-D5B54484795E}',
  DominoSwissTM = '{61CD5357-4D1E-E0CF-CBE0-08EAA8478A39}',
  DominoSwissUTC = '{4E1FBB10-9283-7779-6D79-7D190ECE33FF}',

  DominoSwissEGate = '{1252F612-CF3F-4995-A152-DA7BE31D4154}',
  BrelagConfigurator = '{7979B248-1D5C-4607-8F75-8CB50CD69E34}',
}

export const DOMINO_SWISS_MODULE_IDS = [
  DominoSwissModuleType.DominoSwissMXFEShutter.valueOf(),
  DominoSwissModuleType.DominoSwissMXSLIM.valueOf(),
  DominoSwissModuleType.DominoSwissMXFEULTRA.valueOf(),
  DominoSwissModuleType.DominoSwissLXDIMM.valueOf(),
  DominoSwissModuleType.DominoSwissLXRLUP.valueOf(),
  DominoSwissModuleType.DominoSwissMAG.valueOf(),
  DominoSwissModuleType.DominoSwissWeatherstation.valueOf(),
  DominoSwissModuleType.DominoSwissGroup.valueOf(),
  DominoSwissModuleType.DominoSwissPIR.valueOf(),
  DominoSwissModuleType.DominoSwissTM.valueOf(),
  DominoSwissModuleType.DominoSwissUTC.valueOf(),

  DominoSwissModuleType.DominoSwissEGate.valueOf(),
  DominoSwissModuleType.BrelagConfigurator.valueOf(),
]

export enum FunctionType {
  // PHP
  PHP_SLEEP = 'sleep',

  // Script
  RUN_SCRIPT = 'RUN_SCRIPT',

  // Event
  SET_EVENT_ACTIVE = 'SET_EVENT_ACTIVE',

  // BRELAG
  BRELAG_ContinuousDown = 'BRELAG_ContinuousDown',
  BRELAG_ContinuousUp = 'BRELAG_ContinuousUp',
  BRELAG_LockLevelClear = 'BRELAG_LockLevelClear',
  BRELAG_LockLevelSet = 'BRELAG_LockLevelSet',
  BRELAG_PulseDown = 'BRELAG_PulseDown',
  BRELAG_PulseUp = 'BRELAG_PulseUp',
  BRELAG_RestorePosition = 'BRELAG_RestorePosition',
  BRELAG_Save = 'BRELAG_Save',
  BRELAG_SendCommand = 'BRELAG_SendCommand',
  BRELAG_Stop = 'BRELAG_Stop',
  BRELAG_Move = 'BRELAG_Move',
  BRELAG_RestorePositionBoth = 'BRELAG_RestorePositionBoth',
  BRELAG_Toggle = 'BRELAG_Toggle',
}

export enum FunctionParameterType {
  INTEGER,
  BOOLEAN,
}

export enum FunctionParamaterName {
  // General
  TIME = 'Zeit',
  ACTIVE = 'Aktiv',
  PRIORITY = 'Priorität',
  VALUE = 'Wert',
  COMMAND = 'Kommando',

  // Object IDs
  SCRIPT = 'Script',
  EVENT_ID = 'Ereignis',
}

export interface FunctionDescriptor {
  type: FunctionType
  name: string
  description: string
  templateId: string
  params: {
    name: FunctionParamaterName
    type: FunctionParameterType
  }[]
}

const FUNCTIONS: Map<FunctionType, FunctionDescriptor> = new Map<
  FunctionType,
  FunctionDescriptor
>([
  /** PHP **/
  [
    FunctionType.PHP_SLEEP,
    {
      type: FunctionType.PHP_SLEEP,
      name: 'PHP_SLEEP',
      description: 'Pausiert Ablauf für gewisse Zeit.',
      templateId: '{ADF91538-A489-46DD-9D0B-405F8EB138D3}',
      params: [
        {
          name: FunctionParamaterName.TIME,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],

  /** SCRIPT **/
  [
    FunctionType.RUN_SCRIPT,
    {
      type: FunctionType.RUN_SCRIPT,
      name: 'RUN_SCRIPT',
      description:
        'Die Funktion veranlasst den Start des Skripts mit der ID SkriptID. Das aufgerufene Skript läuft parallel (gleichzeitig) zum aufrufenden Skript.',
      templateId: '{118F0D4A-40CA-8353-C9A4-435476134691}',
      params: [
        {
          name: FunctionParamaterName.SCRIPT,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],

  /** EVENT **/
  [
    FunctionType.SET_EVENT_ACTIVE,
    {
      type: FunctionType.SET_EVENT_ACTIVE,
      name: 'SET_EVENT_ACTIVE',
      description: 'Aktiviert / deaktiviert ein Ereignis.',
      templateId: '{3534F55A-BFC9-F260-33B6-E01CCC4394A1}',
      params: [
        {
          name: FunctionParamaterName.EVENT_ID,
          type: FunctionParameterType.INTEGER,
        },
        {
          name: FunctionParamaterName.ACTIVE,
          type: FunctionParameterType.BOOLEAN,
        },
      ],
    },
  ],

  /** BRELAG **/
  [
    FunctionType.BRELAG_ContinuousDown,
    {
      type: FunctionType.BRELAG_ContinuousDown,
      name: 'BRELAG_ContinuousDown',
      description: 'Schaltet einen Aktor herunterzufahren.',
      templateId: '{17FD5F61-220C-48CD-9D2B-22D46E86ADA0}',
      params: [
        {
          name: FunctionParamaterName.PRIORITY,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_ContinuousUp,
    {
      type: FunctionType.BRELAG_ContinuousUp,
      name: 'BRELAG_ContinuousUp',
      description: 'Schaltet einen Aktor heraufzufahren.',
      templateId: '{655EFB41-07AC-427E-B227-C6D7D2BD6AD4}',
      params: [
        {
          name: FunctionParamaterName.PRIORITY,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_LockLevelClear,
    {
      type: FunctionType.BRELAG_LockLevelClear,
      name: 'BRELAG_LockLevelClear',
      description: 'Entsperrt das Sperrlevel mit dem Wert $Wert.',
      templateId: '{CD48A11B-6735-4307-B9B0-C23DBDCB79F6}',
      params: [
        {
          name: FunctionParamaterName.VALUE,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_LockLevelSet,
    {
      type: FunctionType.BRELAG_LockLevelSet,
      name: 'BRELAG_LockLevelSet',
      description: 'Sperrt das Sperrlevel mit dem Wert $Wert.',
      templateId: '{D1C961F6-1975-4CD2-8A68-C3A8E5BB6932}',
      params: [
        {
          name: FunctionParamaterName.VALUE,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_PulseDown,
    {
      type: FunctionType.BRELAG_PulseDown,
      name: 'BRELAG_PulseDown',
      description: 'Sendet einen Impuls runter auf den Aktor.',
      templateId: '{14506AA4-EF39-40D5-8AB8-1B02635C3455}',
      params: [
        {
          name: FunctionParamaterName.PRIORITY,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_PulseUp,
    {
      type: FunctionType.BRELAG_PulseUp,
      name: 'BRELAG_PulseUp',
      description: 'Sendet einen Impuls hoch auf den Aktor.',
      templateId: '{413E7E8C-E31F-43E3-A1A7-635050BACBA0}',
      params: [
        {
          name: FunctionParamaterName.PRIORITY,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_RestorePosition,
    {
      type: FunctionType.BRELAG_RestorePosition,
      name: 'BRELAG_RestorePosition',
      description: 'Ruft den gespeicherten Wert ab.',
      templateId: '{91C66C2C-B91F-496D-AE69-E1A07A37F61C}',
      params: [
        {
          name: FunctionParamaterName.PRIORITY,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_Save,
    {
      type: FunctionType.BRELAG_Save,
      name: 'BRELAG_Save',
      description: 'Speichert den Momentanen Wert.',
      templateId: '{63F24473-EF6B-4DB7-AB13-AA6E03152032}',
      params: [
        {
          name: FunctionParamaterName.PRIORITY,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_SendCommand,
    {
      type: FunctionType.BRELAG_SendCommand,
      name: 'BRELAG_SendCommand',
      description:
        'Sendet das Kommando $KOmmando mit der Priorität $Priorität und dem Wert $Wert.',
      templateId: '{09D71973-9419-44C5-BA43-B1B202FBF9E2}',
      params: [
        {
          name: FunctionParamaterName.COMMAND,
          type: FunctionParameterType.INTEGER,
        },
        {
          name: FunctionParamaterName.PRIORITY,
          type: FunctionParameterType.INTEGER,
        },
        {
          name: FunctionParamaterName.VALUE,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_Stop,
    {
      type: FunctionType.BRELAG_Stop,
      name: 'BRELAG_Stop',
      description: 'Stoppt den Aktor.',
      templateId: '{0E2BF912-5D79-4880-9A7D-47D7544137B8}',
      params: [
        {
          name: FunctionParamaterName.PRIORITY,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_Move,
    {
      type: FunctionType.BRELAG_Move,
      name: 'BRELAG_Move',
      description: 'Schaltet einen Aktor und fährt diesen auf den Wert $Wert.',
      templateId: '{3BD794E6-C3F1-4E2C-BF58-E78CC91303FC}',
      params: [
        {
          name: FunctionParamaterName.PRIORITY,
          type: FunctionParameterType.INTEGER,
        },
        {
          name: FunctionParamaterName.VALUE,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_RestorePositionBoth,
    {
      type: FunctionType.BRELAG_RestorePositionBoth,
      name: 'BRELAG_RestorePositionBoth',
      description: 'Ruft den gespeicherten Wert ab.',
      templateId: '{89472058-08C4-4159-80F4-420241194716}',
      params: [
        {
          name: FunctionParamaterName.PRIORITY,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
  [
    FunctionType.BRELAG_Toggle,
    {
      type: FunctionType.BRELAG_Toggle,
      name: 'BRELAG_Toggle',
      description: 'Schaltet den Aktor um.',
      templateId: '{78AF78E7-C271-4BB3-98B6-250C36921384}',
      params: [
        {
          name: FunctionParamaterName.PRIORITY,
          type: FunctionParameterType.INTEGER,
        },
      ],
    },
  ],
])

export function getFunctionDescriptor(
  functionType: FunctionType
): FunctionDescriptor {
  return FUNCTIONS.get(functionType)
}

export function getFunctionDescriptorByTemplateId(
  templateId: string
): FunctionDescriptor {
  for (const func of FUNCTIONS.values()) {
    if (func.templateId === templateId) {
      return func
    }
  }
  return null
}

export function getFunctionParams(functionType: FunctionType) {
  return FUNCTIONS.get(functionType).params
}

export function getModuleTypeFromId(moduleID: string): DominoSwissModuleType {
  switch (moduleID) {
    case DominoSwissModuleType.DominoSwissMXFEShutter.valueOf():
      return DominoSwissModuleType.DominoSwissMXFEShutter
    case DominoSwissModuleType.DominoSwissMXSLIM.valueOf():
      return DominoSwissModuleType.DominoSwissMXSLIM
    case DominoSwissModuleType.DominoSwissLXDIMM.valueOf():
      return DominoSwissModuleType.DominoSwissLXDIMM
    case DominoSwissModuleType.DominoSwissLXRLUP.valueOf():
      return DominoSwissModuleType.DominoSwissLXRLUP
    case DominoSwissModuleType.DominoSwissMAG.valueOf():
      return DominoSwissModuleType.DominoSwissMAG
    case DominoSwissModuleType.DominoSwissWeatherstation.valueOf():
      return DominoSwissModuleType.DominoSwissWeatherstation
    case DominoSwissModuleType.DominoSwissGroup.valueOf():
      return DominoSwissModuleType.DominoSwissGroup
    default:
      break
  }
}

export function getPhpFunctions(): FunctionDescriptor[] {
  return [FUNCTIONS.get(FunctionType.PHP_SLEEP)]
}

export function getScriptFunctions(): FunctionDescriptor[] {
  return [FUNCTIONS.get(FunctionType.RUN_SCRIPT)]
}

export function getEventFunctions(): FunctionDescriptor[] {
  return [FUNCTIONS.get(FunctionType.SET_EVENT_ACTIVE)]
}

export function functionsForModule(
  moduleType: DominoSwissModuleType
): FunctionDescriptor[] {
  switch (moduleType) {
    case DominoSwissModuleType.DominoSwissMXFEShutter:
    case DominoSwissModuleType.DominoSwissMXSLIM:
    case DominoSwissModuleType.DominoSwissLXRLUP:
      return [
        FUNCTIONS.get(FunctionType.BRELAG_ContinuousDown),
        FUNCTIONS.get(FunctionType.BRELAG_ContinuousUp),
        FUNCTIONS.get(FunctionType.BRELAG_LockLevelClear),
        FUNCTIONS.get(FunctionType.BRELAG_LockLevelSet),
        FUNCTIONS.get(FunctionType.BRELAG_PulseDown),
        FUNCTIONS.get(FunctionType.BRELAG_PulseUp),
        FUNCTIONS.get(FunctionType.BRELAG_RestorePosition),
        FUNCTIONS.get(FunctionType.BRELAG_Save),
        FUNCTIONS.get(FunctionType.BRELAG_SendCommand),
        FUNCTIONS.get(FunctionType.BRELAG_Stop),
      ]
    case DominoSwissModuleType.DominoSwissLXDIMM:
      return [
        FUNCTIONS.get(FunctionType.BRELAG_ContinuousDown),
        FUNCTIONS.get(FunctionType.BRELAG_ContinuousUp),
        FUNCTIONS.get(FunctionType.BRELAG_LockLevelClear),
        FUNCTIONS.get(FunctionType.BRELAG_LockLevelSet),
        FUNCTIONS.get(FunctionType.BRELAG_Move),
        FUNCTIONS.get(FunctionType.BRELAG_PulseDown),
        FUNCTIONS.get(FunctionType.BRELAG_PulseUp),
        FUNCTIONS.get(FunctionType.BRELAG_RestorePosition),
        FUNCTIONS.get(FunctionType.BRELAG_Save),
        FUNCTIONS.get(FunctionType.BRELAG_SendCommand),
        FUNCTIONS.get(FunctionType.BRELAG_Stop),
      ]
    case DominoSwissModuleType.DominoSwissGroup:
      return [
        FUNCTIONS.get(FunctionType.BRELAG_ContinuousDown),
        FUNCTIONS.get(FunctionType.BRELAG_ContinuousUp),
        FUNCTIONS.get(FunctionType.BRELAG_LockLevelClear),
        FUNCTIONS.get(FunctionType.BRELAG_LockLevelSet),
        FUNCTIONS.get(FunctionType.BRELAG_Move),
        FUNCTIONS.get(FunctionType.BRELAG_PulseDown),
        FUNCTIONS.get(FunctionType.BRELAG_PulseUp),
        FUNCTIONS.get(FunctionType.BRELAG_RestorePosition),
        FUNCTIONS.get(FunctionType.BRELAG_RestorePositionBoth),
        FUNCTIONS.get(FunctionType.BRELAG_Save),
        FUNCTIONS.get(FunctionType.BRELAG_SendCommand),
        FUNCTIONS.get(FunctionType.BRELAG_Stop),
        FUNCTIONS.get(FunctionType.BRELAG_Toggle),
      ]
    case DominoSwissModuleType.DominoSwissMAG:
    case DominoSwissModuleType.DominoSwissWeatherstation:
      return []
    default:
      break
  }
}
